import api from './http';

export const AuthAPI = {
  login: (payload) => api.post('/auth/login', payload).then((response) => response.data),
  register: (payload) => api.post('/auth/register', payload).then((response) => response.data),
  me: () => api.get('/auth/me').then((response) => response.data),
  updateMyFocusPreferences: (payload) => api.patch('/auth/me/focus-preferences', payload).then((response) => response.data),
  listUsers: () => api.get('/auth/users').then((response) => response.data),
  updateUser: (code, payload) => api.patch(`/auth/users/${code}`, payload).then((response) => response.data),
};
